import { useMutation } from 'react-query';
import { JsonObject } from 'type-fest';

import { AddOnData, MutationFunction, useRequest } from '@frontend/api';

export const useUpdateAddOn: MutationFunction<
  AddOnData,
  {
    addOnId: number;
    data: {
      notes?: string;
      name?: string;
      overrides?: JsonObject;
      position?: number;
      isRequired?: boolean;
    };
  }
> = ({ requestOptions, queryOptions, query } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation({
    mutationFn: ({ addOnId, data }) =>
      request(`/quotes/components/add_ons/${addOnId}`, {
        init: { method: 'PATCH', body: data },
        query,
      }),
    ...queryOptions,
  });
};
